window.SEOSnippetPreview = window.SEOSnippetPreview || {}; // VITE_MIGRATION: ensure namespace exists before submodule assignment
SEOSnippetPreview.Platform = class {
  constructor(platformConfig, options) {
    const blankConfig = {
      id: "",
      isSocialNetwork: false,
      urlType: "full",
      shareLink: false,
      // Target character lengths for snippet fields
      // NOTE: We want all keys explicitly specified because when we apply the platform targets, we want to clear any
      // previous targets that the new platform doesn't care about
      targets: {
        title: null,
        description: null,
      },
      // How far off the target we allow before warning the user
      thresholds: {
        title: 10,
        description: 10,
      },
    };

    jQuery.extend(true, this, blankConfig, platformConfig);
    this.options = {
      editable: true,
      snippet_text_behaviour: "edit-snippet",
      snippet_image_behaviour: "edit-snippet-thumbnail",
    };
    this.el = jQuery(`<div class="seo-platform platform-${this.id}">`);
    this.path = window.location.pathname.replace("/edit", "");

    jQuery.extend(this.options, options);
  }

  createShareLink() {
    return this.getShareLink(true);
  }

  getShareLink(autoCreate) {
    if (this.shareLink) {
      var defered = jQuery.Deferred();
      return defered.resolve().promise();
    } else {
      return jQuery.get(`${this.path}/social_share.json`, { service: this.id, auto_create: autoCreate }, (data) => {
        this.shareLink = data.shortcut_url;
      });
    }
  }
};
